export const API_PATHS = {
  OAUTH_URL: '/oauth/',
  AUTH_URL: '/v1/auth/',
  CATALOG_URL: '/v1/catalog/',
  CONCEPTS_URL: '/v1/concepts/',
  FILES_URL: '/v1/files/',
  INGEST_URL: '/v3/ingest/',
  REDEMPTION_URL: '/v1/redemption/',
  POLICY_URL: '/v1/policy/',
  ADMIN_URL: '/v1/admin/',
} as const;

export const AUTH_HEADER = 'authorization';
export const XELACORE_DOMAIN = '.xelacore.io';
export const USER_REFRESH_COOKIE = 'user_refresh_token';
export const USER_COOKIE = 'user_token';

export const EXPIRATION_TIME = 86400000; // 24h in milliseconds

export const HTTP_STATUS = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
} as const;
